import { Controller } from '@hotwired/stimulus'

export default class ProgressWheelController extends Controller<SVGElement> {
  declare percentValue: number
  declare readonly circleTarget: SVGCircleElement

  static targets = ['circle']
  static values = { percent: Number }

  // Value change callbacks

  percentValueChanged() {
    this.#setCircleDashOffset()
  }

  // Public methods

  setTo(percent: number) {
    this.percentValue = percent
  }

  // Private methods

  #setCircleDashOffset() {
    const circumference = parseFloat(this.circleTarget.getAttribute('stroke-dasharray'))
    const offset = circumference * (1 - this.percentValue / 100)

    this.circleTarget.setAttribute('stroke-dashoffset', offset.toString())
  }
}
